module.exports = __webpack_public_path__ + "static/media/admin_normal.fc0d8c47.svg";